import { Form as unform } from "@unform/web";

import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  display: grid;
  grid-gap: 32px;
  height: fit-content;
  padding: 32px;
  width: 100%;

  ${media.greaterThan("medium")`
    padding: 48px;
  `}
`;

export const Form = styled(unform)`
  display: flex;
  gap: 30px;
  justify-content: center;
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.white};
  direction: ltr;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 20px 40px;
  height: 100%;

  ${media.greaterThan("medium")`
    gap: 90px;
    padding: 60px 70px;
  `}
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.neutral.neutral8};
  ${({ theme }) => theme.font.all.xl};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  text-align: center;
  width: 142px;
`;

export const Doubt = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.neutral.neutral9};
  cursor: pointer;
  display: flex;
  gap: 8px;
  ${({ theme }) => theme.font.all.x};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  position: fixed;
  bottom: 20px;
`;
